import { Box } from '@mui/material'
import { useCallback } from 'react'
import { useStyles } from './styles'

interface IAutomationStatus {
  status: 'finished' | 'pending'
}

const AutomationStatus = ({ status }: IAutomationStatus) => {
  const classes = useStyles()

  const changeStyleByStatus = useCallback(
    (status: IAutomationStatus['status']) => {
      switch (status) {
        case 'pending':
          return classes.containerPending
        case 'finished':
          return classes.containerCompleted
        default:
          break
      }
    },
    [status]
  )

  return (
    <Box className={changeStyleByStatus(status)}>
      <span className={classes.status}>{status === 'pending' ? 'Pendente' : 'Finalizado'}</span>
    </Box>
  )
}

export default AutomationStatus
